import type { PagesRouterPage } from "@/types"

import Head from "next/head"
import { usePathname } from "next/navigation"
import { useContext } from "react"

import { Layout } from "@jobteaser/ui-kit/components/Layout/Layout"
import { Text, TEXT_TYPES, TEXT_WEIGHTS } from "@jobteaser/ui-kit/dist/module/components/Text/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useActiveSlugsFetch } from "@/modules/jobSearchPrefiltered/hooks/useActiveSlugsFetch"
import { FoLayout } from "@/modules/layouts/components/FoLayout"
import { ServerContext } from "@/modules/server/context"

import { ActiveSlugs } from "./ActiveSlugs"

import styles from "./List.module.css"

export const List: PagesRouterPage = () => {
  const pathname = usePathname()
  const { baseUrl, hostname } = useContext(ServerContext) || { baseUrl: "", hostname: "" }
  const { t } = useTranslation(["job_search_prefiltered"])
  const { dataActiveSlugs } = useActiveSlugsFetch()

  return (
    <FoLayout host={hostname}>
      <Head>
        <title>{t("job_search_prefiltered.index.meta_title")}</title>
        <meta name="description" content={t("job_search_prefiltered.index.meta_description")} />
        <link rel="canonical" href={`${baseUrl}${pathname}`} />
      </Head>

      <Layout className={styles.layout} as="header">
        <Layout.Column>
          <Text resetSpacing tag="h1" type={TEXT_TYPES.HEADING} weight={TEXT_WEIGHTS.EXTRA_BOLD}>
            {t("job_search_prefiltered.index.title")}
          </Text>
        </Layout.Column>
      </Layout>

      {dataActiveSlugs ? <ActiveSlugs /> : null}
    </FoLayout>
  )
}
